<template>
  <div>
    <v-container v-if="!loadingChart">
      <v-row dense>
        <v-col cols="6" class="section-item-title"
          ><span class="section-item-title">
            Question: {{ activity.name }}</span
          >
        </v-col>
        <v-col cols="2" class="section-stats-display"
          ><v-icon color="gray">schedule</v-icon
          ><span>{{ totalDuration }}</span></v-col
        >
        <v-col cols="2" class="section-stats-display"
          ><v-icon color="gray">mdi-account</v-icon
          ><span>{{ uniqueAgentsCount }}</span></v-col
        >
        <v-col cols="2" class="section-stats-display"
          ><v-icon color="gray">mdi-check</v-icon
          ><span>{{ score }}%</span></v-col
        >
      </v-row>
      <v-row dense>
        <horizontal-bar-chart
          style="position: relative; width:90%; height:25vh"
          :chart-data="chartData"
          :options="chartOptions"
        />
      </v-row>
      <log-dialog
        :headers="headers"
        :logData="logData"
        :showDialog="showDialog"
        :title="dialogTitle"
        :isLoading="loading"
        :csvFilename="csvFilename"
        :courseId="course.id"
      />
    </v-container>
  </div>
</template>

<script>
import HorizontalBarChart from './HorizontalBarChart.vue'
import LogDialog from './LogDialog.vue'
import {
  getDuration,
  Multiset,
  roundToTwo,
  questionTableHeader,
  questionTitle,
  sortDataByDate,
  TOTAL_ITEMS,
  ellipsisLongText
} from '../Constants'
import moment from 'moment'
import _ from 'lodash'

export default {
  props: {
    activity: {
      type: Object,
      required: true
    },
    course: {
      type: Object,
      required: true
    }
  },
  components: {
    HorizontalBarChart,
    LogDialog
  },
  data() {
    return {
      chartData: {},
      chartOptions: {},
      uniqueAgentsCount: 0,
      totalDuration: null,
      score: null,
      loading: true,
      loadingChart: false,
      headers: [],
      logData: [],
      showDialog: false,
      dialogTitle: '',
      csvFilename: ''
    }
  },
  mounted() {
    this.loadingChart = true
    this.fillChartData()
    this.loadingChart = false
  },
  methods: {
    onClickChoice(event, array) {
      this.logData = []
      const lebel = array[0]._chart.tooltip._data.labels[array[0]._index]
      const metadata = array[0]._chart.tooltip._data.metadata

      const courseName = this.course.name.replace(/\s+/g, '_')
      this.dialogTitle = questionTitle
      this.headers = questionTableHeader
      this.csvFilename = courseName + '_question_log'
      this.loading = true
      this.showDialog = true

      const choiceData = _.find(metadata, {
        userResponse: lebel
      })

      if (choiceData !== undefined && choiceData != null) {
        choiceData.interactions.forEach(element => {
          if (element.duration != null && element.duration !== undefined) {
            element.duration = getDuration(element.duration)
          }

          if (element.score != null && element.score !== undefined) {
            element.score = roundToTwo(element.score)
          }
          this.logData.push(element)
        })
      }
      this.logData = sortDataByDate(this.logData)
      this.loading = false
    },
    fillChartData() {
      let correctResponseCount = 0
      let labels = new Array()
      let metadata = new Array()
      let backgroundColor = new Array()
      let correctResponse = this.activity.interactions[0].activity.definition
        .correctResponsesPattern[0]
      const uniqueAgents = new Multiset()
      this.activity.interactions.forEach(element => {
        uniqueAgents.add(element.name)

        if (element.response === 'Correct') {
          correctResponseCount++
        }

        if (element.duration) {
          if (this.totalDuration == null) {
            this.totalDuration = moment.duration(element.duration)
          } else {
            this.totalDuration = moment
              .duration(element.duration)
              .add(this.totalDuration)
          }
        }
      })
      // set totals
      this.totalDuration = getDuration(this.totalDuration)
      this.uniqueAgentsCount = uniqueAgents.size
      this.score = roundToTwo(
        parseFloat(
          (correctResponseCount / this.activity.interactions.length) * 100
        )
      )

      // chart data
      metadata = _.chain(this.activity.interactions)
        .groupBy('userResponse')
        .map((value, key) => ({ userResponse: key, interactions: value }))
        .value()
      let data = new Array()
      this.activity.interactions[0].activity.definition.choices.forEach(
        element => {
          labels.push(element.id)
          backgroundColor.push(
            element.id === correctResponse ? '#7ed321' : '#f5a623'
          )
          let obj = _.find(metadata, { userResponse: element.id })
          if (obj !== undefined && obj != null) {
            data.push(
              roundToTwo(
                parseFloat(
                  (obj.interactions.length /
                    this.activity.interactions.length) *
                    100
                )
              )
            )
          } else {
            data.push(0)
          }
        }
      )

      this.chartOptions = {
        layout: {
          padding: {
            right: 10
          }
        },
        legend: {
          display: false
        },
        hover: {
          onHover: function(e) {
            e.target.style.cursor = 'pointer'
          }
        },
        onClick: this.onClickChoice,
        responsive: true,
        maintainAspectRatio: false,
        tooltips: {
          callbacks: {
            title: function(tooltipItem, data) {
              return ellipsisLongText(
                data['labels'][tooltipItem[0]['index']],
                31
              )
            },
            label: function(tooltipItem, data) {
              const metadata = data['metadata']
              const choiceData = _.find(metadata, {
                userResponse: tooltipItem.label
              })
              //const choiceData = data['metadata'][tooltipItem['index']]
              let toolTip = new Array()
              if (choiceData !== undefined && choiceData != null) {
                choiceData.interactions.forEach(element => {
                  if (toolTip.length < TOTAL_ITEMS) {
                    toolTip.push(ellipsisLongText(element.name, 31))
                  }
                })
              }
              if (choiceData.interactions.length > TOTAL_ITEMS) {
                const diff = choiceData.interactions.length - TOTAL_ITEMS
                toolTip.push(`and ${diff} more`)
              }
              return toolTip
            }
            // afterLabel: function(tooltipItem, data) {
            //   return '(kaka)'
            // }
          },
          backgroundColor: '#FFF',
          titleFontSize: 10,
          titleFontColor: '#000',
          bodyFontColor: '#000',
          bodyFontSize: 12,
          displayColors: false,
          borderWidth: 0.2,
          borderColor: '#000',
          hoverBorderColor: '#000',
          hoverBorderWidth: 10
        },
        scales: {
          xAxes: [
            {
              ticks: {
                min: 0,
                suggestedMin: 50,
                suggestedMax: 100,
                stepSize: 5
              },
              scaleLabel: {
                display: true,
                labelString: 'Percent'
              }
            }
          ],
          yAxes: [
            {
              scaleLabel: {
                display: true,
                labelString: 'Answers'
              },
              stacked: true,
              gridLines: {
                display: false
              }
            }
          ]
        }
      }

      this.chartData = {
        labels: labels,
        metadata: metadata,
        datasets: [
          {
            //label: 'Dataset 1',
            backgroundColor: backgroundColor,
            data: data
          }
        ]
      }
    }
  }
}
</script>

<style>
.section-item-title {
  color: #0fa0df;
  font-weight: 500;
  font-size: 20px;
}
</style>
